/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Timecode_InInputs */

const en_ccsl_export_header_timecode_in = /** @type {(inputs: Ccsl_Export_Header_Timecode_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode In`)
};

const fr_ccsl_export_header_timecode_in = /** @type {(inputs: Ccsl_Export_Header_Timecode_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode entree`)
};

const de_ccsl_export_header_timecode_in = /** @type {(inputs: Ccsl_Export_Header_Timecode_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode In`)
};

const it_ccsl_export_header_timecode_in = /** @type {(inputs: Ccsl_Export_Header_Timecode_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice temporale in entrata`)
};

const ru_ccsl_export_header_timecode_in = /** @type {(inputs: Ccsl_Export_Header_Timecode_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ввод временного кода`)
};

const es_ccsl_export_header_timecode_in = /** @type {(inputs: Ccsl_Export_Header_Timecode_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada de código de tiempo`)
};

const zh_cn2_ccsl_export_header_timecode_in = /** @type {(inputs: Ccsl_Export_Header_Timecode_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码输入`)
};

const ja_ccsl_export_header_timecode_in = /** @type {(inputs: Ccsl_Export_Header_Timecode_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコード入力`)
};

const hi_ccsl_export_header_timecode_in = /** @type {(inputs: Ccsl_Export_Header_Timecode_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड में`)
};

const pt_pt2_ccsl_export_header_timecode_in = /** @type {(inputs: Ccsl_Export_Header_Timecode_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tempo em`)
};

/**
* | output |
* | --- |
* | "Timecode In" |
*
* @param {Ccsl_Export_Header_Timecode_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_timecode_in = /** @type {((inputs?: Ccsl_Export_Header_Timecode_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Timecode_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_timecode_in(inputs)
	if (locale === "de") return de_ccsl_export_header_timecode_in(inputs)
	if (locale === "it") return it_ccsl_export_header_timecode_in(inputs)
	if (locale === "ru") return ru_ccsl_export_header_timecode_in(inputs)
	if (locale === "es") return es_ccsl_export_header_timecode_in(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_timecode_in(inputs)
	if (locale === "ja") return ja_ccsl_export_header_timecode_in(inputs)
	if (locale === "hi") return hi_ccsl_export_header_timecode_in(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_timecode_in(inputs)
	return en_ccsl_export_header_timecode_in(inputs)
});